import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconPhone: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7934 18.1265C13.4109 18.1265 13.0259 18.0748 12.6459 17.9707C7.50841 16.5607 3.4409 12.4957 2.03007 7.36152C1.70924 6.19402 1.88502 4.97735 2.52669 3.93735C3.17086 2.89235 4.23008 2.15485 5.43258 1.91485C6.23258 1.75485 7.02341 2.11152 7.42924 2.79569L8.73173 4.99567C9.36423 6.06401 9.04995 7.43984 8.01579 8.12818L7.0734 8.75485C7.95424 10.5632 9.43578 12.049 11.2366 12.929L11.8718 11.9815C12.5643 10.949 13.9401 10.6398 15.0076 11.2757L17.2101 12.589C17.8918 12.9957 18.2442 13.7915 18.0892 14.5682C17.8492 15.7707 17.1117 16.8298 16.0675 17.474C15.3659 17.9057 14.585 18.1265 13.7934 18.1265ZM5.81506 3.12484C5.77423 3.12484 5.73259 3.12902 5.69259 3.13736C4.81425 3.31319 4.05342 3.84234 3.59176 4.59317C3.13426 5.33484 3.0084 6.20068 3.23673 7.02985C4.5309 11.7407 8.26339 15.4715 12.9767 16.7649C13.8067 16.9924 14.67 16.8657 15.4108 16.409C16.1608 15.9465 16.6909 15.1848 16.8634 14.3215C16.9151 14.0623 16.7976 13.7965 16.5693 13.6607L14.3675 12.3473C13.8717 12.0523 13.2317 12.1965 12.91 12.6757L11.9808 14.0632C11.8142 14.3115 11.4926 14.4065 11.2209 14.2915C8.75178 13.259 6.7426 11.2457 5.70927 8.76734C5.59427 8.49067 5.69081 8.17235 5.93998 8.00651L7.32426 7.08567C7.80426 6.7665 7.95005 6.12734 7.65588 5.63151L6.35339 3.43233C6.23923 3.239 6.03256 3.12484 5.81506 3.12484Z"
      fill={color}
    />
  </svg>
);

export default IconPhone;
